// extracted by mini-css-extract-plugin
export default {"InputsContainer":"TopicSearch_InputsContainer__JldJ-","Search":"TopicSearch_Search__98WsW","SearchContainer":"TopicSearch_SearchContainer__G75C0","Icon":"TopicSearch_Icon__TuPTu"};